import { application } from "./controllers/application"

// Heavy widgets are registered only when their controller appears, including in
// Turbo frames/streams. Registering with Stimulus connects all current elements.
const pending = new Map()
let observer
export function registerLazyController(identifier, loader) {
  pending.set(identifier, { loader, loading: false })
  if (!observer) {
    observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === "attributes") loadWithin(record.target)
        else record.addedNodes.forEach(loadWithin)
      }
    })
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-controller"] })
    document.addEventListener("turbo:load", () => loadWithin(document))
  }
  loadWithin(document)
}

function loadWithin(root) {
  if (!root.querySelector) return
  for (const [identifier, entry] of pending) {
    const selector = `[data-controller~="${identifier}"]`
    if (entry.loading || !(root.matches?.(selector) || root.querySelector(selector))) continue
    entry.loading = true
    entry.loader().then(module => {
      application.register(identifier, module.default)
      pending.delete(identifier)
    }).catch(error => {
      entry.loading = false
      console.error(`Unable to load ${identifier}`, error)
    })
  }
}
